export const json = (
  data: unknown,
  statusData?: { status: number; statusText?: string },
) =>
  new Response(JSON.stringify(data), {
    ...(statusData && statusData),
    headers: { 'Content-Type': 'application/json' },
  });
